module.exports = __webpack_public_path__ + "img/five-full-star.526ddd08.svg";